<template>
  <div style="padding: 10px">
    <!-- 功能区域 -->
    <div style="margin: 10px 0">
      <el-button type="primary" @click="add">新增</el-button>
      <el-button type="warning" @click="refreshCache">刷新缓存</el-button>
    </div>

    <!-- 搜索区域 -->
    <div style="margin: 10px 0">
      <el-input v-model="search.configKey" placeholder="配置键" style="width: 20%" clearable></el-input>
      <el-input v-model="search.configDesc" placeholder="配置描述" style="width: 20%; margin-left: 5px" clearable></el-input>
      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
    </div>

    <!-- 表格区域 -->
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="id"
          label="ID"
          width="80"
          sortable>
      </el-table-column>
      <el-table-column
          prop="configKey"
          label="配置键"
          width="200"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="configValue"
          label="配置值"
          width="300"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="configDesc"
          label="配置描述"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-button size="mini" type="primary" plain @click="handleEdit(scope.row)">编辑</el-button>
          <el-popconfirm title="确定删除吗？" @confirm="handleDelete(scope.row.id)">
            <template #reference>
              <el-button size="mini" type="danger">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog title="系统配置" v-model="dialogVisible" width="30%">
      <el-form :model="form" label-width="100px">
        <el-form-item label="配置键">
          <el-input v-model="form.configKey" style="width: 80%" placeholder="请输入配置键"></el-input>
        </el-form-item>
        <el-form-item label="配置值">
          <el-input type="textarea" v-model="form.configValue" style="width: 80%" placeholder="请输入配置值" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="配置描述">
          <el-input v-model="form.configDesc" style="width: 80%" placeholder="请输入配置描述"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'sysConfig',
  data() {
    return {
      loading: true,
      dialogVisible: false,
      form: {},
      search: {
        configKey: '',
        configDesc: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: []
    }
  },
  created() {
    this.load();
  },
  methods: {
    // 加载数据
    load() {
      this.loading = true;
      const params = {
        current: this.currentPage,
        size: this.pageSize
      };

      // 添加搜索条件
      if (this.search.configKey) {
        params.configKey = this.search.configKey;
      }
      if (this.search.configDesc) {
        params.configDesc = this.search.configDesc;
      }

      request.get("/sysConfig/listPage", {
        params: params
      }).then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        } else {
          this.$message.error(res.msg || '加载失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error('网络错误，加载失败');
        this.tableData = [];
        this.total = 0;
      });
    },

    // 重置搜索条件
    resetData() {
      this.search = {
        configKey: '',
        configDesc: ''
      };
      this.currentPage = 1;
      this.load();
    },

    // 新增
    add() {
      this.form = {};
      this.dialogVisible = true;
    },

    // 编辑
    handleEdit(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },

    // 保存
    save() {
      if (!this.form.configKey) {
        this.$message.warning('请输入配置键');
        return;
      }

      if (this.form.id) {
        // 更新
        request.post("/sysConfig/update", this.form).then(res => {
          if (res.code === '0') {
            this.$message.success('更新成功');
            this.load();
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg || '更新失败');
          }
        });
      } else {
        // 新增
        request.post("/sysConfig/save", this.form).then(res => {
          if (res.code === '0') {
            this.$message.success('新增成功');
            this.load();
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg || '新增失败');
          }
        });
      }
    },

    // 删除
    handleDelete(id) {
      request.post("/sysConfig/delete/" + id).then(res => {
        if (res.code === '0') {
          this.$message.success('删除成功');
          this.load();
        } else {
          this.$message.error(res.msg || '删除失败');
        }
      });
    },

    // 刷新缓存
    refreshCache() {
      request.post("/sysConfig/refreshCache").then(res => {
        if (res.code === '0') {
          this.$message.success('缓存刷新成功');
        } else {
          this.$message.error(res.msg || '缓存刷新失败');
        }
      });
    },

    // 改变每页显示数量
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },

    // 改变当前页码
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    }
  }
}
</script>

<style scoped>
.el-input {
  margin-right: 10px;
}

.el-table {
  margin-top: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: center;
}
</style>
